import React from "react";
import './testimonials.css'
import useReveal from "../../hooks/useReveal";

const data = [
    {
        id: 1,
        name: "Benjamin McDermott",
        role: "AI Product Manager",
        review: "Sumit was instrumental to the success of AI Catalyst at BrightEdge, playing a foundational role in shaping the data architecture and backend infrastructure that powered the entire feature. He brought deep technical expertise and a sharp eye for scalable design, ensuring we had the right foundation to build on.",
    },
    {
        id: 2,
        name: "Sambit Swain",
        role: "SDE 3 at BrightEdge",
        review: "Sumit is one of the most dependable backend developers I've collaborated with. His strong expertise in Python, ClickHouse, and MySQL consistently helped us design and optimize high-performance systems. He has a rare ability to break down complex problems and implement scalable solutions with precision.",
    },
    {
        id: 3,
        name: "Rudresh Kumar Pandey",
        role: "Team Lead at Mindfire Solutions",
        review: "I was consistently impressed by Sumit's strong expertise in backend development, particularly with Python, GCP, and ClickHouse. He tackles complex problems with clarity, takes ownership of his work, and contributes ideas that elevate team outcomes — a collaborative teammate with clear communication.",
    },
];

const initials = (name) => name.split(" ").map((n) => n[0]).slice(0, 2).join("");

const Testimonials = () => {
    const ref = useReveal();
    return (
        <section id="testimonials">
            <h5>$ cat recommendations.log</h5>
            <h2>Recommendations</h2>
            <div className="container testimonials__container reveal" ref={ref}>
                {data.map(({ id, name, role, review }) => (
                    <article key={id} className="testimonial term-window">
                        <div className="term-titlebar">
                            <span className="term-dot red"></span>
                            <span className="term-dot yellow"></span>
                            <span className="term-dot green"></span>
                            <span className="term-path">linkedin.com/recommendation</span>
                        </div>
                        <div className="testimonial__body">
                            <p className="client__review">"{review}"</p>
                            <div className="client__meta">
                                <div className="client__avatar mono">{initials(name)}</div>
                                <div>
                                    <h5 className="client__name">{name}</h5>
                                    <small className="txt-muted">{role}</small>
                                </div>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    )
}

export default Testimonials
